import { render, staticRenderFns } from "./PointSearch.vue?vue&type=template&id=5b3f08fa&scoped=true"
import script from "./PointSearch.vue?vue&type=script&lang=ts"
export * from "./PointSearch.vue?vue&type=script&lang=ts"
import style0 from "./PointSearch.vue?vue&type=style&index=0&id=5b3f08fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f08fa",
  null
  
)

export default component.exports